import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "common/scss/index.scss";
import { App, appStore } from "./app";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { ErrorBoundary } from "common/components";
import { installGlobalErrorHandlers } from "common/services/GlobalErrorHandlers";
import "typeface-open-sans";
import "typeface-barlow";

installGlobalErrorHandlers(appStore);

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container '#root' not found");
}
const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <Router>
      <Provider store={appStore}>
        <App />
      </Provider>
    </Router>
  </ErrorBoundary>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
